var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 23,
    viewBox: "0 0 20 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.27248 3.96922C2.48958 3.96922 1.8549 4.60389 1.8549 5.3868V18.9956C1.8549 19.7785 2.48958 20.4131 3.27248 20.4131H16.8812C17.6642 20.4131 18.2988 19.7785 18.2988 18.9956V5.3868C18.2988 4.60389 17.6642 3.96922 16.8812 3.96922H3.27248ZM0.153809 5.3868C0.153809 3.6644 1.55009 2.26813 3.27248 2.26813H16.8812C18.6036 2.26813 19.9999 3.6644 19.9999 5.3868V18.9956C19.9999 20.718 18.6036 22.1142 16.8812 22.1142H3.27248C1.55009 22.1142 0.153809 20.718 0.153809 18.9956V5.3868Z",
    fill: "#ACB0B9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.6131 0C15.0829 0 15.4637 0.380803 15.4637 0.850548V5.3868C15.4637 5.85655 15.0829 6.23735 14.6131 6.23735C14.1434 6.23735 13.7626 5.85655 13.7626 5.3868V0.850548C13.7626 0.380803 14.1434 0 14.6131 0Z",
    fill: "#ACB0B9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.54061 0C6.01035 0 6.39116 0.380803 6.39116 0.850548V5.3868C6.39116 5.85655 6.01035 6.23735 5.54061 6.23735C5.07087 6.23735 4.69006 5.85655 4.69006 5.3868V0.850548C4.69006 0.380803 5.07087 0 5.54061 0Z",
    fill: "#ACB0B9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.153809 9.92305C0.153809 9.45331 0.534612 9.07251 1.00436 9.07251H19.1494C19.6191 9.07251 19.9999 9.45331 19.9999 9.92305C19.9999 10.3928 19.6191 10.7736 19.1494 10.7736H1.00436C0.534612 10.7736 0.153809 10.3928 0.153809 9.92305Z",
    fill: "#ACB0B9"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.80874 14.4593C7.80874 13.833 8.31647 13.3252 8.9428 13.3252H10.0769C10.7032 13.3252 11.2109 13.833 11.2109 14.4593C11.2109 15.0856 10.7032 15.5934 10.0769 15.5934H8.9428C8.31647 15.5934 7.80874 15.0856 7.80874 14.4593Z",
    fill: "#ACB0B9"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0769 13.6088C10.5466 13.6088 10.9274 13.9896 10.9274 14.4593V17.8615C10.9274 18.3312 10.5466 18.712 10.0769 18.712C9.60712 18.712 9.22632 18.3312 9.22632 17.8615V14.4593C9.22632 13.9896 9.60712 13.6088 10.0769 13.6088Z",
    fill: "#ACB0B9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDate);
export default __webpack_public_path__ + "static/media/date.3b9d3c768e0d6afba45470e682303639.svg";
export { ForwardRef as ReactComponent };